// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3Yyqh","disabled":"FileBtn_disabled__2G-0M","warn":"FileBtn_warn__BHMqt","fade":"FileBtn_fade__12oPI"};